import { BaseResponse, TableList } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export interface VersionItem {
  id: number;
  versionNumber: string;
  versionContent: string;
  versionContentEn: string;
  versionContentJa: string;
  versionContentZh: string;
  versionUpdate: number;
  createTime: string;
  updateTime: string;
  createUserName: string;
  updateUserName: string;
}

export interface VersionListParams {
  versionNumber?: string;
  pageSize: number;
  currentPage: number;
}

export interface VersionListResponse {
  total: number;
  currentPage: number;
  pageSize: number;
  records: VersionItem[];
}

export interface VersionAddParams {
  versionNumber: string;
  versionContent: string;
  versionContentEn: string;
  versionContentJa: string;
  versionContentZh: string;
  versionUpdate: number;
}

export interface VersionUpdateParams extends VersionAddParams {
  id: number;
}

export interface AppVersionSwitchStatus {
  status: number;
  updateTime: string;
  updateUserName: string | null;
}

export interface AppStoreStatus {
  status:
    | 'PREPARE_FOR_SUBMISSION'
    | 'WAITING_FOR_REVIEW'
    | 'IN_REVIEW'
    | 'PENDING_DEVELOPER_RELEASE'
    | 'READY_FOR_SALE'
    | 'REJECTED';
  version: string;
  updateTime: string;
  description?: string;
}

export const getVersionList = async (params: VersionListParams) => {
  const { currentPage = 1, pageSize = 20, ...body } = params;
  const res = await axiosInstance.post<BaseResponse<TableList<VersionItem>>>(
    `${baseUrl}/api/version/queryPageList?currentPage=${currentPage}&pageSize=${pageSize}`,
    body
  );
  return res.data;
};

export const addVersion = async (params: VersionAddParams) => {
  const res = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/api/version/add`,
    params
  );
  return res.data;
};

export const updateVersion = async (params: VersionUpdateParams) => {
  const res = await axiosInstance.put<BaseResponse<void>>(
    `${baseUrl}/api/version/update`,
    params
  );
  return res.data;
};

export const deleteVersion = async (id: number) => {
  const res = await axiosInstance.delete<BaseResponse<void>>(
    `${baseUrl}/api/version/delete/${id}`
  );
  return res.data;
};

// 查询版本开关状态
export const queryAppVersionSwitch = async () =>
  axiosInstance.get<BaseResponse<AppVersionSwitchStatus>>(
    `${baseUrl}/api/app/config/query/appVersionSwitch`
  );

// 修改版本开关状态
export const updateAppVersionSwitch = async (status: number) =>
  axiosInstance.put<BaseResponse<AppVersionSwitchStatus>>(
    `${baseUrl}/api/app/config/switch/appVersionSwitch/${status}`
  );

// 查询版本开关状态
export const queryAppVersionSwitchAndroid = async () =>
  axiosInstance.get<BaseResponse<AppVersionSwitchStatus>>(
    `${baseUrl}/api/app/config/query/appVersionSwitchAndroid`
  );

// 修改版本开关状态
export const updateAppVersionSwitchAndroid = async (status: number) =>
  axiosInstance.put<BaseResponse<AppVersionSwitchStatus>>(
    `${baseUrl}/api/app/config/switch/appVersionSwitchAndroid/${status}`
  );

// 注册后会员弹窗开关(code: registerMemberPopupIos / registerMemberPopupAndroid)
export const queryRegisterMemberPopup = async (code: string) =>
  axiosInstance.get<BaseResponse<AppVersionSwitchStatus>>(
    `${baseUrl}/api/app/config/query/${code}`
  );

export const updateRegisterMemberPopup = async (code: string, status: number) =>
  axiosInstance.put<BaseResponse<AppVersionSwitchStatus>>(
    `${baseUrl}/api/app/config/switch/${code}/${status}`
  );

// 查询 App Store 状态
export const queryAppStoreStatus = async () =>
  axiosInstance.get<BaseResponse<AppStoreStatus>>(
    `${baseUrl}/api/app/store/status`
  );
